import nightUrl from "@/assets/desktop-mockup/night.png";
import trailUrl from "@/assets/desktop-mockup/trail.png";

import type { FractionRect } from "@/composables/useOverlayRect";

export type MockupPeriod = "day" | "night";

export interface DesktopMockup {
  id: string;
  src: string;
  period: MockupPeriod;
  screenRect: FractionRect;
  cornerRadiusRatio: number;
}

export const DESKTOP_MOCKUPS: DesktopMockup[] = [
  {
    id: "trail",
    src: trailUrl,
    period: "day",
    screenRect: { left: 0.4339, top: 0.166, width: 0.1317, height: 0.6201 },
    cornerRadiusRatio: 0.1073,
  },
  {
    id: "night",
    src: nightUrl,
    period: "night",
    screenRect: { left: 0.4387, top: 0.166, width: 0.1309, height: 0.6172 },
    cornerRadiusRatio: 0.1116,
  },
];

export const MOCKUP_NATURAL_SIZE = { width: 2300, height: 1024 };

const NIGHT_START_HOUR = 18;
const NIGHT_END_HOUR = 6;

export function getCurrentMockupPeriod(now: Date = new Date()): MockupPeriod {
  const hour = now.getHours();
  return hour >= NIGHT_START_HOUR || hour < NIGHT_END_HOUR ? "night" : "day";
}

export const useDesktopMockup = () => {
  const period = getCurrentMockupPeriod();
  const candidates = DESKTOP_MOCKUPS.filter((item) => item.period === period);
  const pool = candidates.length > 0 ? candidates : DESKTOP_MOCKUPS;
  const index = Math.floor(Math.random() * pool.length);
  const mockup = pool[index] ?? pool[0]!;

  return {
    mockup,
    naturalSize: MOCKUP_NATURAL_SIZE,
    screenRect: mockup.screenRect,
  };
};
